import { useMutation, useQueryClient } from "@tanstack/react-query";

import { resetRepoTemplate } from "./api";
import type { RepoBranchTemplateResponse } from "./api";

// DELETE per-repo override (репозиторий снова наследует org-дефолт).
// На успех инвалидируем repo-запрос этого репозитория.
export function useResetRepoTemplate(): ReturnType<
  typeof useMutation<RepoBranchTemplateResponse, Error, string>
> {
  const queryClient = useQueryClient();
  return useMutation<RepoBranchTemplateResponse, Error, string>({
    mutationFn: (repoFullName) => resetRepoTemplate(repoFullName),
    onSuccess: (_data, repoFullName) => {
      void queryClient.invalidateQueries({
        queryKey: ["branchNameTemplate", "repo", repoFullName],
      });
    },
  });
}
